import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "fieldKey", "fields", "module"];
import { Component } from 'react';
import classNames from 'classnames';
import H5 from 'UIComponents/elements/headings/H5';
import UITruncateString from 'UIComponents/text/UITruncateString';
import FieldKeyLabel from 'ContentComponents/cmv2/FieldKeyLabel';
import HelpTooltip from 'ContentComponents/cmv2/HelpTooltip';
import SanitizedLabel from 'ContentComponents/cmv2/SanitizedLabel';
import { getFieldFromKey } from 'ContentComponents/cmv2/utils';
import { jsx as _jsx } from "react/jsx-runtime";
class EditFormHeader extends Component {
  renderFieldKeyHelpText() {
    const {
      fieldKey,
      fields
    } = this.props;
    const field = getFieldFromKey(fields, fieldKey) || {};
    const {
      help_text: helpText
    } = field;
    if (helpText) {
      return /*#__PURE__*/_jsx(HelpTooltip, {
        iconProps: {
          className: 'm-left-1'
        },
        title: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: helpText
        })
      });
    }
    return null;
  }
  render() {
    const _this$props = this.props,
      {
        className,
        fieldKey,
        fields,
        module
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    let {
      label
    } = this.props;
    if (fieldKey) {
      label = /*#__PURE__*/_jsx(FieldKeyLabel, Object.assign({}, rest, {
        fieldKey: fieldKey,
        fields: fields,
        module: module
      }));
    }
    if (!label) {
      return null;
    }
    const classes = classNames('cmv2-edit-form-label', className);
    return /*#__PURE__*/_jsx(H5, {
      className: classes,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        useFlex: true,
        fixedChildren: fieldKey && this.renderFieldKeyHelpText(),
        children: label
      })
    });
  }
}
export default EditFormHeader;